export const products = [
  {
    id: "qsc-001",
    name: "Hydro Balance Moisturizer",
    slug: "hydro-balance-moisturizer",
    category: "skin-care",
    categoryName: "Skin Care",
    price: 49.95,
    description: "Intensiv feuchtigkeitsspendende Gesichtscreme mit liposomalem AKG und reinem Bergquellwasser. Für strahlend frische und natürlich schöne Haut.",
    shortDescription: "Intensiver Feuchtigkeits-Booster mit AKG-Liposomen",
    volume: "30ml",
    image: "https://storage.helloreaddy.io/project_files/23c94d18-5867-4539-9c50-49f9128bb6d3/bae6665b-c4ae-44dc-b6b2-4826ca0ae9a2_compressed__QOQO-HYDRO-BALANCE-Airless--Schachtel.webp",
    ingredients: ["Reines Bergquellwasser", "AKG-Liposome", "Hyaluronsäure", "Sheabutter", "Vitamin E", "Aloe Vera"],
    badges: ["Vegan", "Halal", "Ohne Parfüm"],
    inStock: true,
  },
];

export const productCategories = [
  { id: "skin-care", name: "Skin Care", slug: "skin-care", description: "Hydro Balance – Feuchtigkeitspflege für strahlend schöne Haut", image: "https://storage.helloreaddy.io/project_files/23c94d18-5867-4539-9c50-49f9128bb6d3/55fb2374-791a-4b67-b6ed-c4c388e4f7a2_compressed_1S3B7314.webp", comingSoon: false },
  { id: "reinigung", name: "Reinigungsprodukte", slug: "reinigung", description: "Sanfte Reinigung mit reinem Quellwasser", image: "https://storage.helloreaddy.io/project_files/23c94d18-5867-4539-9c50-49f9128bb6d3/77bf8db5-3622-403d-b8b3-e4953b540bd7_compressed_1S3B7280.webp", comingSoon: true },
  { id: "men-care", name: "Men Care", slug: "men-care", description: "Pflege für die anspruchsvolle Männerhaut", image: "https://readdy.ai/api/search-image?query=Confident%20man%20with%20healthy%20clear%20skin%20applying%20skincare%20product%2C%20minimalist%20modern%20bathroom%20setting%2C%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20premium%20men%20grooming%20editorial%20photography&width=400&height=400&seq=qoqo-cat-men&orientation=squarish", comingSoon: true },
  { id: "anti-aging", name: "Anti Aging", slug: "anti-aging", description: "Wissenschaftlich fundierte Anti-Aging-Pflege", image: "https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20with%20radiant%20youthful%20skin%20touching%20face%20gently%2C%20soft%20golden%20lighting%2C%20warm%20neutral%20tones%2C%20luxury%20anti-aging%20skincare%20editorial%20photography%2C%20clean%20minimalist%20background&width=400&height=400&seq=qoqo-cat-aging&orientation=squarish", comingSoon: true },
];

export const uspFeatures = [
  { icon: "ri-drop-line", title: "100% Reines Bergquellwasser", description: "Aus einem Naturschutzgebiet in Deutschland" },
  { icon: "ri-flask-line", title: "Wirkstoffbasierte Formulierungen", description: "Mit liposomalem AKG – eine Weltneuheit" },
  { icon: "ri-heart-pulse-line", title: "Besonders Hautverträglich", description: "Dermatologisch getestet und zertifiziert" },
  { icon: "ri-seedling-line", title: "Eigene Produktentwicklung", description: "Wissenschaftlicher Beirat & eigenes Entwicklungsteam" },
  { icon: "ri-leaf-line", title: "Hoher Anteil natürlicher Inhaltsstoffe", description: "Vegan und nachhaltig verpackt" },
];

export const certifications = [
  { name: "Halal", icon: "ri-shield-check-line", description: "Vollständig Halal-zertifiziert" },
  { name: "Vegan", icon: "ri-plant-line", description: "100% vegan und tierversuchsfrei" },
  { name: "Made in Germany", icon: "ri-map-pin-line", description: "Produziert in Deutschland" },
  { name: "Natrue", icon: "ri-award-line", description: "NATRUE-zertifiziert" },
];

export const brandAvoids = [
  "Ohne Alkohol",
  "Ohne Konservierungsstoffe",
  "Ohne Allergene",
  "Ohne Parfüm (Duftstoffe)",
  "Ohne Mikroplastik",
  "Ohne Erd- & Mineralöle",
  "Ohne Silikone",
  "Ohne Tierversuche",
];

export const brandAdvantages = [
  "100% reines Quellwasser",
  "Weltneuheit AKG-Liposome",
  "Eigene Rezeptur",
  "Mehrfach zertifiziert",
  "Made in Germany",
  "Nachhaltige Verpackungen",
  "Langjährige Forschung",
  "Eigene Entwicklung",
];